import { getTableColumns } from "@/pages/consumption/view/billing-details/view/volume-detail/config/table-columns";

export function useTableColumns(is88StudioSubAccount: boolean) {
  return { columns: getTableColumns(is88StudioSubAccount) };
}
